import { useEffect, useState } from "react";
import {
    api, getEventById, getEventInfosByEventId, getTicketTypeInfosByTicketTypeId, getTicketTypeNumberOfAvailableTickets,
    getTicketTypesByEventId, getTicketTypePriceForOrder,
} from "ticketino-api-client";
import axios from 'axios';

import Loading from "./Loading";

const TicketSelect = (props) => {

    //----variables----

    //developement env dependent
    const baseUrl = process.env.REACT_APP_BASE_TICKETINO_URL;
    const baseProxyUrl = process.env.REACT_APP_PLUGIN_PROXY;

    //prop values
    const selectedEventId = props.eventId;
    const selectedEventGroupId = props.eventGroupId;
    const orderId = props.orderId;
    const token = props.token;
    const singleTicketAsCB = props.singleTicketAsCB;
    const showTicketDescription = props.showTicketDescription;
    const disableTickets = props.disableTickets ?? "";
    const enableTickets = props.enableTickets ?? "";
    const selectedLanguageCode = props.languageCode;
    const changeLanguage = props.changeLanguage;
    const selectedLanguage = props.languageISO;
    const currency = props.selectedCurrency ?? "CHF";
    const allowUnlockTicketTypes = props.allowUnlockTicketTypes;
    const showEventBanner = props.showEventBanner;
    const showTicketTypesAsList = props.showTicketTypesAsList;

    //mutateable
    const [orderIdParameter, setOrderIdParameter] = useState(0);
    const [resources, setResources] = useState([]);

    const [event, setEvent] = useState({});
    const [ticketTypes, setTicketTypes] = useState([]);
    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);

    const [loading, setLoading] = useState(true);
    const [disabled, setDisabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState();
    const [disabledTickets, setDisabledTickets] = useState([]);

    const [selectedTicketTypes, setSelectedTicketTypes] = useState([]);

    const [promotionCode, setPromotionCode] = useState(""); //promotion code
    const [promotionCodeMessage, setPromotionCodeMessage] = useState("");
    const [isPromotionCodeAdded, setIsPromotionCodeAdded] = useState(false);
    const [isTicketsAvailable, setIsTicketsAvailable] = useState(false);

    useEffect(() => {
        requestResources(selectedLanguage);
    }, [selectedLanguage]);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        api.defaults.baseURL = baseUrl;

        if (orderId == 0) {
            startOrder();
        } else {
            loadEvent(selectedEventId, orderId);
        }

        if (orderId > 0) {
            setOrderIdParameter(orderId);
        }

        loadDisabledTickets();
    }, [orderId])

    useEffect(() => {
        loadEvent(selectedEventId, orderIdParameter);
    }, [isPromotionCodeAdded])

    const requestResources = async (langauge) => {
        await axios
            .get(`${baseProxyUrl}/resources/${langauge}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadDisabledTickets = () => {
        let ticketTypesToBeDisabled = [];

        //example string "123123123;1232131|1231231;123123;123123"
        //               Group 1           | Group 2
        enableTickets.split("|").map((ticketGroup) => {
            let tickets = ticketGroup.split(";");

            for (var i = 1; i < tickets.length; i++) {
                if (!(selectedTicketTypes.includes(tickets[0].trim()))) {
                    ticketTypesToBeDisabled.push(tickets[i].trim())
                }
            }
        })

        setDisabledTickets(ticketTypesToBeDisabled);
    }

    const loadEvent = async (eventId, orderId) => {

        if (eventId === 0 || orderId === 0) {
            return;
        }

        try {

            //event
            const event = await getEventById(eventId);
            const infos = await getEventInfosByEventId(eventId);

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: infos };

            const ticketTypes = await getTicketTypesByEventId(eventId);
            const updatedTicketTypes = await Promise.all(
                ticketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    const ticketTypeInfo = info;

                    var unlockpromotionCode = "";

                    if (isPromotionCodeAdded) {
                        if (unlockedTicketTypes?.includes(ticketType.id)) {
                            unlockpromotionCode = promotionCode
                        }
                    }

                    const ticketTypeAvailability = unlockpromotionCode != "" ?
                        await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId, unlockpromotionCode) :
                        await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    const ticketTypePrice = await getTicketTypePriceForOrder(orderId, ticketType.id);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability, updatedPrice: ticketTypePrice }
                })
            )

            if (!updatedTicketTypes || updatedTicketTypes.length === 0
                || !(updatedTicketTypes.some(tt => tt.availability?.availableTickets > 0 && tt.availability?.status === 0))) {
                setIsTicketsAvailable(false);
            }
            else {
                setIsTicketsAvailable(true);
            }

            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setLoading(false);

        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }

    const startOrder = async () => {
        let currencyForBody = currency.toUpperCase();

        if (!(currencyForBody == "CHF" || currencyForBody == "EUR" || currencyForBody == "USD" || currencyForBody == "GBP")) {
            currencyForBody = "CHF";
        }

        let startOrderBody = {
            currency: currencyForBody,
            tenantId: 1,
            pointOfSaleId: 6585,
            paymentType: 1,
            languageId: selectedLanguageCode,
            paymentType: 1
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, startOrderBody)
            .then((result) => {
                setOrderIdParameter(result.data.id);
                loadEvent(selectedEventId, result.data.id);
            })
            .catch((error) => console.error(error.response.data));
    }

    const applyPromotion = async () => {
        setPromotionCodeMessage("");
        const order = await applyPromotionCodeToOrder(orderIdParameter, promotionCode);
        setUnlockedTicketTypes(order.unlockedTicketTypes);
        setIsPromotionCodeAdded(true);
        //loadEvent(selectedEventId, orderIdParameter);
    }

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionCodeMessage(resources.detailPage?.errorMessage);
        }
    }

    const onTicketTypeChange = (e, ticketTypeId) => {
        const obj = {
            ticketTypeId: ticketTypeId,
            quantity: e.target.value,
        };

        const existingTicketType = selectedTicketTypes.find(
            (t) => t.ticketTypeId === ticketTypeId
        );

        if (existingTicketType) {
            existingTicketType.quantity = e.target.value;
        } else {
            selectedTicketTypes.push(obj);
        }

        // calcualate quantity and validate
        let quantity = 0;

        selectedTicketTypes.map(s => {
            quantity += s.quantity * 1;
        });

        if (quantity > 0) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

        updateDisabledTickets(quantity, ticketTypeId);
    };

    const onTicketTypeCheckboxChange = (e, ticketTypeId) => {
        const obj = {
            ticketTypeId: ticketTypeId,
            quantity: 1,
        };

        let updatedSelectedTicketTypes = [...selectedTicketTypes];

        if (e.target.checked) {
            updatedSelectedTicketTypes.push(obj);
        } else {
            updatedSelectedTicketTypes = updatedSelectedTicketTypes.filter(ustt => ustt.ticketTypeId != ticketTypeId);
        }

        // calcualate quantity and validate
        let quantity = 0;

        updatedSelectedTicketTypes.map(s => {
            quantity += s.quantity * 1;
        });

        if (quantity > 0) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

        setSelectedTicketTypes(updatedSelectedTicketTypes);
        updateDisabledTickets(quantity, ticketTypeId);
    }

    const addTicketsToBasket = async () => {
        let addTicketTypes = [];
        let canContinue = true;

        addTicketTypes = selectedTicketTypes.filter((stt) => stt.quantity !== "0");

        if (isPromotionCodeAdded) {

            addTicketTypes.map((ticketType) => {
                if (unlockedTicketTypes?.includes(ticketType.ticketTypeId)) {
                    ticketType.promotionCode = promotionCode
                }
            });
        }

        addTicketTypes.map((ticketType) => {
            if (disabledTickets.includes(`${ticketType.ticketTypeId}`)) {
                setErrorMessage(resources.ticketPage?.errorMessageDisabledTicketSelected);
                canContinue = false;
            }
        })

        if (canContinue) {
            const order = await addTicketsToShopBasket(orderIdParameter, addTicketTypes);

            if (order) {
                props.changeTicketTypesInformation(ticketTypes);

                props.changeOrderId(order.id);
                props.changePage(1);
            }
        }
    }

    const addTicketsToShopBasket = async (orderId, ticketstoAdd) => {

        console.log(ticketstoAdd);
        try {
            const response = await axios.post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, { ticketstoAdd: ticketstoAdd });
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setErrorMessage(resources.ticketPage?.generalErrorMessage)
        }
    }

    //updates the disabled ticket array
    const updateDisabledTickets = (amount, ticketTypeIdGiven) => {
        let ticketTypesToBeDisabled = [];

        if (amount > 0) {
            disableTickets.split("|").map((ticketGroup) => {

                let ticketTypeIds = ticketGroup.split(";");

                if (ticketTypeIds[0] == `${ticketTypeIdGiven}`) {
                    for (var i = 0; i < ticketTypeIds.length; i++) {
                        ticketTypesToBeDisabled.push(ticketTypeIds[i + 1]);
                    }
                }
            });
        }

        disableTickets.split("|").map((ticketGroup) => {

            let ticketTypeIds = ticketGroup.split(";");
            let hasBeenFound = false;

            selectedTicketTypes.map((stt) => {
                if (stt.ticketTypeId == ticketTypeIds[0]) {
                    hasBeenFound = true;
                }
            })

            if (hasBeenFound === true) {
                for (var i = 1; i < ticketTypeIds.length; i++) {
                    ticketTypesToBeDisabled.push(ticketTypeIds[i].trim())
                }
            }
        })

        enableTickets.split("|").map((ticketGroup) => {

            let ticketTypeIds = ticketGroup.split(";");
            let hasBeenFound = false;

            selectedTicketTypes.map((stt) => {
                if (stt.ticketTypeId == ticketTypeIds[0] && stt.quantity > 0) {
                    hasBeenFound = true;
                }
            })

            if (hasBeenFound === false) {
                for (var i = 1; i < ticketTypeIds.length; i++) {
                    ticketTypesToBeDisabled.push(ticketTypeIds[i].trim())
                }
            }
        })

        setDisabledTickets(ticketTypesToBeDisabled);
    }

    //change the user selected langauge
    const updateLanguage = (language) => {
        requestResources(language);
        changeLanguage(language)
    }

    const languageSelectDiv = () => {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-auto ms-auto">
                        <select
                            className="ticketinoSelect form-select"
                            aria-label=""
                            value={selectedLanguage}
                            onChange={(e) => {
                                updateLanguage(e.currentTarget.value);
                            }}
                        >
                            <option value={"en"} key={1} >{"en"}</option>
                            <option value={"de"} key={2} >{"de"}</option>
                            <option value={"fr"} key={3} >{"fr"}</option>
                            <option value={"it"} key={4} >{"it"}</option>
                        </select>
                    </div>
                </div>
            </div>
        )
    }

    const eventInfoDiv = () => {
        const eventInfo = event.info?.eventInfos?.find((i) => i.languageId == selectedLanguageCode) ?? event.info?.eventInfos?.find((i) => i.languageId == 0);

        return (
            <div className="row mb-4">
                <div className="col-12">
                    {(eventInfo?.bannerImagePath?.length > 0 && showEventBanner == "true") &&
                        <img className="img-fluid mb-4" src={eventInfo?.bannerImagePath} width="100%"></img>}
                    <p className="ticketinoText text titleStyle text-start text-right fs-3 fw-semibold mb-2 text-break text-start">{eventInfo?.name}</p>
                    <p className="ticketinoText text fs-6 text-right text-break text-start">{eventInfo?.shortDescription}</p>
                </div>
            </div>
        )
    }

    const promotionCodeDiv = () => {
        return (
            <div className="mb-4 row mt-5">
                <div className="col-9">
                    <input
                        type="text"
                        name="firstname"
                        className="ticketinoInput form-control inputCodeFirstname"
                        placeholder={resources.detailPage?.labelPromotioncode}
                        id="inputCode"
                        onChange={(event) => setPromotionCode(event.currentTarget.value)}
                    />
                </div>
                <button className="ticketinoButton btn button btn-light col-3" disabled={promotionCode == ""} onClick={applyPromotion}>{resources.detailPage?.buttonLabelUseCode}</button>
                <div className="ticketinoText text fs-6 text-start ticketinoError mt-2">
                    {promotionCodeMessage}
                </div>
                <div className="ticketinoText text fs-6 text-start ticketinoError mt-2">
                    {errorMessage}
                </div>
            </div>
        )
    }

    const mapTicketTypes = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        ticketTypesSorted = ticketTypesSorted.map((ticketType) => {

            const ticketTypeInfo = ticketType.info?.find(info => info.languageId === selectedLanguageCode) ?? ticketType.info?.find(info => info.languageId === 0);

            //taking the default value when info doesnt exist
            return { ...ticketType, info: ticketTypeInfo };
        });

        let ticketTypeClassName = "ticketObjectDiv pt-2 pb-2";
        let ticketTypeParentClassName = "";

        if (showTicketTypesAsList == "false") {
            ticketTypeClassName += " showAsBox p-2"
            ticketTypeParentClassName = "row";
        }

        return (
            <>
                {showTicketTypesAsList == "false" ? <></> :
                    <div className="ticketObjectDiv row" >
                        <div className="col-md-8 col-6 fs-6 fw-bold">
                            {resources.ticketPage?.Kategorie}
                        </div>
                        <div className="ticketinoText col-md-2 col-3 text-start p-0">
                            <p className="m-0 fw-bold">{resources.ticketPage?.PriceText}</p> {resources.ticketPage?.IncludeMwst}
                        </div>
                        <div className="ticketinoText col-md-2 col-3 text-start fw-bold p-0">
                            {resources.ticketPage?.Amount}
                        </div>
                    </div>}
                <hr></hr>
                <div className={ticketTypeParentClassName}>
                    {ticketTypes &&
                        ticketTypes.length > 0 &&
                        ticketTypesSorted.map((tt, index) => (
                            <div className={showTicketTypesAsList == "false" ? "col-md-6" : ""} key={index}>
                                {
                                    tt.availability?.status === 0 &&
                                    (
                                        <>
                                            <div className={ticketTypeClassName}>
                                                <div className="row">
                                                    <div className="col-md-8 col-6 p-0">
                                                        <label className="ticketinoText fs-6">
                                                            {tt.info?.name}
                                                        </label>
                                                        {showTicketDescription == "true" && <div className="ticketinoText description text-secondary">
                                                            {tt.info?.description}
                                                        </div>}
                                                    </div>
                                                    <div className={`col-md-2 col-3 ${showTicketTypesAsList == "false" ? "text-center" : "text-start"} p-0`}>
                                                        <label className="ticketinoText">
                                                            {tt.currency} {tt.updatedPrice.toFixed(2)}
                                                        </label>
                                                    </div>
                                                    <div className="col-md-2 col-3 p-0">
                                                        {(singleTicketAsCB == "true" || tt.maxNumberOfTicketsPerOrder == 1) ?
                                                            <div className="form-check text-center col-8">
                                                                <input
                                                                    className="ticketinoInput form-check-input"
                                                                    type="checkbox"
                                                                    id={"flexCheckDefault" + tt.id}
                                                                    disabled={disabledTickets.includes(`${tt.id}`)}
                                                                    checked={selectedTicketTypes?.some(st => st.ticketTypeId == tt.id)}
                                                                    onChange={(e) => onTicketTypeCheckboxChange(e, tt.id)}
                                                                >
                                                                </input>
                                                            </div> :
                                                            <select
                                                                className="ticketinoSelect form-select"
                                                                onChange={(e) => onTicketTypeChange(e, tt.id)}
                                                                disabled={disabledTickets.includes(`${tt.id}`)}
                                                            >
                                                                {Array.from(
                                                                    Array(
                                                                        tt.availability?.availableTickets + 1
                                                                    ),
                                                                    (e, i) => {
                                                                        return (
                                                                            <option key={i} value={i}>
                                                                                {i}
                                                                            </option>
                                                                        );
                                                                    }
                                                                )}
                                                            </select>}
                                                    </div>
                                                </div>
                                            </div>
                                            {showTicketTypesAsList == "false" ? <></> : <hr></hr>}
                                        </>
                                    )}
                            </div>
                        ))}
                </div>
            </>
        );
    }

    //-----HTML Display------
    return (
        <div className="page-container">
            {languageSelectDiv()}
            {loading ? <Loading /> : <div className="container">
                {eventInfoDiv()}
                {(allowUnlockTicketTypes === "true") && promotionCodeDiv()}
                {(allowUnlockTicketTypes === "true") && isPromotionCodeAdded && unlockedTicketTypes?.length > 0 &&
                    <div class="alert alert-success p-2 mb-3" role="alert" >
                        {resources.ticketPage?.PromotionCodeApplied}
                    </div>}
                {!isTicketsAvailable &&
                    <div className="alert alert-danger" role="alert">
                        {resources.ticketPage?.NoTicketAvailable}
                    </div>}
                {isTicketsAvailable && mapTicketTypes()}
                <div className="ticketinoText ticketinoError text fs-6 text-center mt-3">
                    {errorMessage}
                </div>

                {selectedEventGroupId > 0 && <button className="button btn-grey btn-ticketino-large mb-3" onClick={() => props.changePage(-1)} >
                    {resources.customerPage?.buttonLabelPrevious}
                </button>}
                {isTicketsAvailable && <button className="button btn-orange btn-ticketino-large float-end mb-4" disabled={disabled} onClick={addTicketsToBasket}>
                    {resources.ticketPage?.buttonLabelContinue}
                </button>}
            </div>}
        </div>
    )

}

export default TicketSelect;